import { defineMessages } from 'react-intl';

export const reportIssueApprovalMessages = defineMessages({
  headerBug: {
    defaultMessage: 'Report an issue',
    id: '9uub5ITfdl',
    description: 'Header of the agent-drafted issue report approval card',
  },
  reviewBug: {
    defaultMessage: 'Review this report before Heidi sends it to our support team.',
    id: 'kR0cHbmlHq',
    description: 'Subheader of the issue report approval card',
  },
  headerSafety: {
    defaultMessage: 'Report a clinical safety issue',
    id: 'MQ8lMezY2w',
    description:
      'Header of the issue report card when the report goes to the clinical safety team',
  },
  safetyRoutes: {
    defaultMessage:
      "Heidi can't send clinical safety reports. To report this, open the session note, select thumbs down and tick Safety issue. Or contact support from the Help menu and include the session ID.",
    id: 'uNMsoaJ2bS',
    description:
      'Body of a clinical safety report card parked before Heidi stopped sending safety reports, naming the two ways the user can report it',
  },
  dismissSafety: {
    defaultMessage: 'Dismiss',
    id: '6ZLSEgJSj9',
    description:
      'Button that closes a clinical safety report card without sending anything',
  },
  attachedDetails: {
    defaultMessage:
      "We'll attach your session, account and app details so the team can investigate.",
    id: '675IHcgTNK',
    description: 'Note on the issue report card listing the details sent with the report',
  },
  descriptionLabel: {
    defaultMessage: 'Report description',
    id: 'pCKC6W/yiV',
    description: 'Accessible label for the editable report description',
  },
  descriptionRequired: {
    defaultMessage: 'A description is required.',
    id: 'sLDg1T/iRl',
    description: 'Validation error when the report description is empty',
  },
  characterCount: {
    defaultMessage: '{count} / {max}',
    id: 'uACpvGciVn',
    description: 'Character counter shown near the description length limit',
  },
  submitBug: {
    defaultMessage: 'Submit',
    id: 'vfpTik9GMf',
    description: 'Submit button on the issue report approval card',
  },
  submitError: {
    defaultMessage:
      "We couldn't send your report. Try again, or contact support from the Help menu.",
    id: 'WcggbMhMAZ',
    description: 'Inline error when resolving the report approval fails',
  },
});
